import {Injectable} from '@angular/core';
import {ApiService} from './api/api.service';
import {Company} from '../classes/company';
import {Azureteam} from '../classes/azureteam';
import {Observable, tap} from 'rxjs';
import {AzureFeature} from '../classes/azurefeature';
import {setCustomerColors} from '../shared/customer-color';

@Injectable({
    providedIn: 'root'
})
export class CompanyService {

    constructor(public apiService: ApiService) {
    }

    getCompany(id: number) {
        return this.apiService.getCallData$<Company>(`companies/${id}`);
    }

    getCompanies(withAzureProject = false) {
        return this.apiService.getCallData$<Company[]>('companies', {withAzureProject});
    }

    saveCompany(company: Company) {
        return this.apiService.postCall$<Company>('companies', company);
    }

    deleteCompany(companyId: number) {
        return this.apiService.deleteCall(`companies/${companyId}`);
    }

    getAzureTeams(): Observable<{ value: Azureteam[] }> {
        return this.apiService.getCallData$<{ value: Azureteam[] }>('companies/azureteams');
    }

    getAzureItems(companyId: number): Observable<any> {
        return this.apiService.getCallData$<any>('companies/azureitems', {companyId});
    }

    getAzureFeatures(companyId: number): Observable<any> {
        return this.apiService.getCallData$<AzureFeature[]>('companies/azurefeatures', {companyId});
    }

    /** Loads the customer colors (company id → #rrggbb) for the customerColor pipe. */
    loadColors(): Observable<Record<number, string>> {
        return this.apiService.getCallData$<Record<number, string>>('companies/colors').pipe(
            tap(colors => setCustomerColors(colors))
        );
    }

    getHavingRegistrations(): Observable<Company[]> {
        return this.apiService.getCallData$<Company[]>('companies/havingregistrations', null);
    }
}
